import React from 'react';

const AreaRiskTable = ({ rows }) => {
  const items = Array.isArray(rows) ? rows : [];

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Area / Region Risk</h3>
      <div className="mt-3 overflow-x-auto rounded-lg border border-slate-800">
        <table className="min-w-full text-xs">
          <thead className="bg-slate-950/80 text-slate-400">
            <tr>
              <th className="px-3 py-2 text-left">Area</th>
              <th className="px-3 py-2 text-right">Active Incidents</th>
              <th className="px-3 py-2 text-right">Affected Customers</th>
              <th className="px-3 py-2 text-right">Overdue Conc.</th>
              <th className="px-3 py-2 text-right">Activation Backlog</th>
              <th className="px-3 py-2 text-right">Risk Score</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => {
              const risk = Number(row.risk_score || 0);
              const riskTone = risk >= 75 ? 'text-red-300' : risk >= 50 ? 'text-amber-300' : 'text-emerald-300';
              return (
                <tr key={row.area_name} className="border-t border-slate-800/80 text-slate-200">
                  <td className="px-3 py-2">{row.area_name}</td>
                  <td className="px-3 py-2 text-right">{Number(row.active_incidents || 0)}</td>
                  <td className="px-3 py-2 text-right">{Number(row.affected_customers || 0)}</td>
                  <td className="px-3 py-2 text-right">{Number(row.overdue_concentration || 0).toFixed(1)}%</td>
                  <td className="px-3 py-2 text-right">{Number(row.activation_backlog || 0)}</td>
                  <td className={`px-3 py-2 text-right font-semibold ${riskTone}`}>{risk.toFixed(1)}</td>
                </tr>
              );
            })}
            {items.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-3 py-3 text-center text-slate-500">Tidak ada area risiko untuk filter ini.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default AreaRiskTable;
